const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  login ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/login/login', params).then((res) => {
      if (res.data.model.accessToken) {
        localStorage.setItem('accessToken', res.data.model.accessToken)
      }
      return res
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/login.js